// Stripe Checkout Session creation -- the client half of the API's billing
// integration (routes/billing.py's POST /v1/billing/stripe/checkout-session).
// `auth: true` attaches the stored JWT as `Authorization: Bearer <token>`;
// the endpoint stamps that user id onto the Checkout Session's
// client_reference_id so the eventual webhook can activate the right account.
//
// The response field is `checkout_url` (mirrors the API's
// CheckoutSessionResponse pydantic model field-for-field) -- NOT `url`. The
// caller redirects the browser to it (window.location = checkout_url) to hand
// the user off to Stripe's hosted, PCI-compliant payment page. The real
// price ($26.99/mo, unified 2026-08-03) lives entirely in Stripe; this client never
// asserts or displays a price it computed itself.

import { apiFetch } from "./client";

export interface CheckoutSessionResponse {
  checkout_url: string;
  session_id: string;
}

export function createCheckoutSession(): Promise<CheckoutSessionResponse> {
  return apiFetch<CheckoutSessionResponse>("/v1/billing/stripe/checkout-session", {
    method: "POST",
    auth: true,
  });
}

// User-initiated subscription cancellation (POST /v1/subscription/cancel --
// the rail-agnostic /v1/subscription router, same home as /status; the API
// half lands in a parallel btclock-api change). `reason` is the ONE optional
// free-text feedback question (marketing request, Owner-cleared 2026-08-29):
// trimmed, capped at 2000 chars, and the field is OMITTED entirely when
// empty. An older server simply ignores an unknown field -- no version
// gating.
export function cancelSubscription(reason?: string): Promise<void> {
  const trimmed = reason?.trim().slice(0, 2000);
  return apiFetch<void>("/v1/subscription/cancel", {
    method: "POST",
    body: trimmed ? { reason: trimmed } : {},
    auth: true,
  });
}
